<template>
  <div class="approval">
    <search-box ref="searchBox" v-slot="{form}">
      <el-button type="primary" :loading="isLoading" @click="initData(form)">
        查询
      </el-button>
      <el-button type="default" @click="resetForm">
        重置
      </el-button>
    </search-box>

    <div class="operate-btn-wrap">
      <el-button type="primary" @click="deriveInfo(5)">
        导出需开票清单
      </el-button>
      <el-button type="default" @click="showGoldenTaxInvoicing">
        导入金税开票信息
      </el-button>
      <el-button type="default" @click="showCourierNumber">
        导入快递单号
      </el-button>
      <el-button type="default" @click="deriveInfo(6)">
        导出已开票信息
      </el-button>
    </div>

    <div v-loading="isLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" tooltip-effect="light">
        <el-table-column prop="approvalNumber" label="申请单号" align="left" width="150" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="handleNum(row)">
              {{ row.approvalNumber }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="left" width="200" fixed="left" />
        <el-table-column prop="contractNum" label="合同编号" align="left" width="150" />
        <el-table-column prop="orderUnit" label="代理商名称" align="left" width="200" />
        <el-table-column prop="invoiceAmount" label="开票金额（含税）" align="right" header-align="left" width="150" />
        <el-table-column prop="revMethod" label="收入确认方式" align="left" width="150" />
        <el-table-column prop="revRule" label="收入确认规则" align="left" width="150" />
        <el-table-column prop="customerType" label="客户类型" align="left" width="150" />
        <el-table-column prop="applicantName" label="申请人" align="left" />
        <el-table-column prop="applicationTime" label="申请时间" align="left" width="150" />
        <el-table-column prop="stateStr" label="状态信息" align="left" width="150" />
        <el-table-column prop="invoiceCode" label="发票代码" align="left" width="150" />
        <el-table-column prop="invoiceNo" label="发票号" align="left" width="150" />
        <el-table-column prop="logisticsNo" label="快递单号" align="left" width="180">
          <template v-slot="{row}">
            <el-button type="text" @click="handleLogistics(row)">
              {{ row.logisticsNo }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="erpConfirm" label="是否已核准" align="left" width="180">
          <template v-slot="{row}">
            <span>{{ row.erpConfirm ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operationFlag" label="操作" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button v-if="row.operationFlag === 1" type="text" @click="openEdit(row)">
              填写
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-size.sync="page.pageSize"
          :current-page.sync="page.pageIndex"
          :total="page.total"
          layout="total, prev, pager, next, jumper"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>

    <!-- 申请单号 -->
    <notice-dialog
      ref="noticeRef"
      :is-show="isNoticeShow"
      :form-data="formDetail"
      :is-receipt="true"
      @down-file="downFile"
      @handle-cancel="handleNumCancel"
    />

    <!-- 快递单号 -->
    <logisticsProcess
      ref="logisticsRef"
      :is-show="islogisticsShow"
      :form-data="formDetail"
      @handle-cancel="islogisticsShow = false"
    />

    <!-- 导入金税开票信息 -->
    <golden-tax-invoicing-dialog
      ref="goldenTaxInvoicing"
      @init-data="initData"
    />

    <!-- 导入快递单号 -->
    <courier-number-dialog
      ref="courierNumber"
      @init-data="initData"
    />

    <!-- 填写 -->
    <el-dialog :title="`开票通知单（${formEdit.approvalNumber}）`" :visible="isShowEdit" width="1000px" @close="handleCancelEdit">
      <fill-out :form-data="formEdit" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="handleCancelEdit">取消</el-button>
        <el-button type="primary" @click="saveEdit">保存</el-button>
      </span>
    </el-dialog>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>

<script>
import searchBox from '../../openTicketManagmentOfcontractAsWhole/components/searchBox.vue';
import noticeDialog from '@/components/noticeDialog';
import logisticsProcess from '@/components/logisticsProcess';
// 导入金税开票信息
import goldenTaxInvoicingDialog from './goldenTaxInvoicingDialog.vue';
// 导入快递单号
import courierNumberDialog from './courierNumberDialog.vue';

import fillOut from './fillOut.vue';
import {
  getPageQueryAppliedInvoice,
  getProcessinfo,
  processExportInvoicedInfo,
  financialEdit,
  attachmentGetToken
} from '@/API/index.js';

export default {
  components: {
    searchBox,
    fillOut,
    noticeDialog,
    logisticsProcess,
    goldenTaxInvoicingDialog,
    courierNumberDialog
  },
  data () {
    return {
      isLoading: false,
      isNoticeShow: false, // 申请单号
      islogisticsShow: false, // 快递单号
      isShowEdit: false, // 填写
      rowDetail: {}, // 当前点击的
      formDetail: {}, // 办理回显
      formEdit: {}, // 编辑数据
      tableData: [],
      token: '',
      downloadUrl: '',
      fileserveDownUrl: '',
      page: {
        pageSize: 10,
        pageIndex: 1,
        total: 0
      }
    };
  },
  mounted () {
    this.initData();
    this.initToken();
  },
  methods: {
    initData () {
      this.isLoading = true;
      const params = {
        approvalRole: 3, // 财务
        approved: true,
        ...this.$refs.searchBox.searchForm,
        ...this.page
      };
      getPageQueryAppliedInvoice(params).then(res => {
        const { data } = res;
        if (data.status === '200') {
          this.tableData = data.data.list;
          this.page.total = data.data.total;
          this.isLoading = false;
        }
      }).catch((e) => {
        this.isLoading = false;
        console.log(e);
      });
    },

    // 申请单号
    handleNum (row) {
      this.rowDetail = {};
      this.rowDetail = row;
      this.isNoticeShow = true;
      getProcessinfo({
        approvalNumber: row.approvalNumber,
        approval: false
      }).then(res => {
        const { data } = res;
        if (data.status === '200') {
          this.formDetail = data.data;
        }
      });
    },

    // 快递单号
    handleLogistics (row) {
      this.rowDetail = {};
      this.rowDetail = row;
      this.islogisticsShow = true;
      this.$refs.logisticsRef.initData(row.logisticsNo);
    },

    resetForm () {
      this.$refs.searchBox.resetForm();
      this.page.pageIndex = 1;
      this.initData();
    },

    // 只用给切换来清内容
    resetFormValue () {
      this.$refs.searchBox.resetForm();
      this.page.pageIndex = 1;
    },

    handerSizeChange () { // 每页多少条
      this.page.pageIndex = 1;
      this.initData();
    },

    handerCurrentChange () { // 当前第几页
      this.initData();
    },

    openEdit (row) { // 填写
      this.isShowEdit = true;
      getProcessinfo({
        approvalNumber: row.approvalNumber,
        approval: false
      }).then(res => {
        const { data } = res;
        if (data.status === '200') {
          this.formEdit = data.data;
        }
      });
    },

    // 填写确定
    saveEdit () {
      const { approvalNumber, invoiceNo, invoiceCode, exportInvoiceNo, logisticsNo, invoiceDate } = this.formEdit;
      const params = {
        approvalNumber,
        invoiceNo,
        invoiceCode,
        exportInvoiceNo,
        logisticsNo,
        invoiceDate
      };
      if (!(invoiceCode && invoiceNo && invoiceDate)) {
        this.$message.error('请填写必填项');
        return;
      }
      console.log(params, 'params');
      financialEdit(params).then(res => {
        const { data } = res;
        if (data.status === '200') {
          this.isShowEdit = false;
          this.initData();
          this.$message.success('提交成功');
          this.formEdit = {};
        }
      });
    },

    // 导出需开票清单
    // 4(待开票状态)   5(待开票状态)      6(审批流程结束)
    deriveInfo (type) {
      processExportInvoicedInfo({
        state: type,
        ...this.$refs.searchBox.searchForm
      }).then((res) => {
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = `${type === 5 ? '需开票清单' : '已开票信息'}` + new Date().toLocaleString() + '.xlsx';
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        console.log(res, 'res');
        if (json.status === '200') {
          this.token = json.data.token;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    downFile (row) {
      this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },

    handleCancelEdit () {
      this.isShowEdit = false;
      this.formEdit = {};
    },

    handleNumCancel () {
      this.isNoticeShow = false;
      this.formDetail = {};
    },

    // 导入金税开票信息
    showGoldenTaxInvoicing () {
      this.$refs.goldenTaxInvoicing.openDialog();
    },

    // 导入快递单号
    showCourierNumber () {
      this.$refs.courierNumber.openDialog();
    }
  }
};
</script>
